import { rem, rgba } from 'polished';
import colors from './colors';

const shadows: ShadowProps = {
  ctaHover: `0 ${rem(6)} ${rem(12)} 0 ${rgba(colors.grey900, 0.24)}`,
  ctaBlueHover: `0 ${rem(24)} ${rem(48)} 0 ${rgba(colors.primary, 0.08)}`,
  dropDownHover: `0 ${rem(10)} ${rem(15)} ${rgba(colors.black, 0.1)}, 0 ${rem(
    4,
  )} ${rem(6)} ${rgba(colors.grey900, 0.04)}`,
  contactBox: `0 ${rem(20)} ${rem(25)} ${rgba(colors.black, 0.1)}, 0 ${rem(
    10,
  )} ${rem(10)} ${rgba(colors.black, 0.04)}`,
  tileShadow: `0 ${rem(20)} ${rem(44)} ${rgba(colors.black, 0.12)}, 0 ${rem(
    23,
  )} ${rem(80)} ${rgba(0, 23, 80, 0.06)}, 0 ${rem(4)} ${rem(6)} ${rgba(
    colors.black,
    0.04,
  )}`,
};

export interface ShadowProps {
  [key: string]: string;
}

export default shadows;
